import React from "react";
import { defaultLanguage } from "src/../src-dynamic/destination.languages";
import ErrorBoundary from "src/components/errorboundary/errorboundary.v1";
import Module from "src/modules/bookingWidget";

const SliceComponent = (props: any) => {
  const { sliceContext } = props;
  return <>
  <ErrorBoundary fallback={null}>
    <Module
      data={{
        selectedLanguage: sliceContext.language,
        defaultLanguage: defaultLanguage,
        item: sliceContext.item
      }}
    />
    </ErrorBoundary>
  </>
}

export default SliceComponent;